import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    lotInOutList: () => {
        return HTTP.get('/lot/list_lot_in_out', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    lotInDetail: (id) => {
        return HTTP.get('/lot/lot_in_detail/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    lotOutDetail: (id,type) => {
        return HTTP.get('/lot/lot_out_detail/'+id+'/'+type, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    lotInUpdate: (id,data) => {
        return HTTP.post('/lot/lot_in_update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    lotOutUpdate: (id,data) => {
        return HTTP.post('/lot/lot_out_update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}